<h1 class="accent-background-element">Select Clinics</h1>
<mat-dialog-content>
  <div class="search">
    <mat-icon matPrefix svgIcon="search" color="accent"></mat-icon>
    <input type="search" placeholder="Search"
      class='mat-body secondary-border-element background-text-element text-input' [formControl]='search'
      list='searchDataList' #searchInput tabindex="1">
    </div>



    <!--  table columns definitions -->
    <table mat-table matSort color="accent" class='closer-sort' aria-label="Elements" [dataSource]="dataSource"
      [matSortActive]="this.dataSource.sortingHeader" [matSortDirection]="this.dataSource.sortDirection">

      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef>
          <!-- checkmark for bulk -->
          <mat-checkbox class="accent-check " (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox class="accent-check " (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
        </td>
      </ng-container>


      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef >
          <h3>ID</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          <h3 class="not-bold">{{row.clinicId}}</h3>

        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Name</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          <h3 class="not-bold">{{row.clinicName}}</h3>

        </td>
      </ng-container>

      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Address</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          <h3 class="not-bold">{{row.addressLine1}},&nbsp; {{row.addressLine2}}</h3>

        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>
    </table>

    <!-- progress indicator that we are to indicate that data is being loaded from the backend  -->
    @if ((this.dataSource.loading$ | async); as loading) {
      <div class="spinner-container">
        <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
      </div>
    }

    <mat-paginator #clinicsPaginator color='accent' [length]="dataSource.count" [pageIndex]=" this.dataSource.pageIndex"
      [pageSize]="this.dataSource.pageSize" [pageSizeOptions]="[10,20,50]">
    </mat-paginator>

  </mat-dialog-content>

  <mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-raised-button color="accent" (click)="onSubmit()">Continue</button>
  </mat-dialog-actions>


  <ng-template #none>
    <mat-icon svgIcon='dash'></mat-icon>
  </ng-template>
  <ng-template #sentButton>
    <button mat-icon-button disabled class="immitation-button" [disabled]="isDisabledButton()">
      <mat-icon svgIcon='checkmark' class="sent-button-icon secondary-contrast-icon"></mat-icon>
    </button>

  </ng-template>